module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Location")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedLocations), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationName",
      "label": "Name",
      "id": "locationName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationName),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationName", $$v)
      },
      expression: "editedLocations.locationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationStreetAddress",
      "label": "Stree Address",
      "id": "locationStreetAddress",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationStreetAddress),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationStreetAddress", $$v)
      },
      expression: "editedLocations.locationStreetAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationCity",
      "label": "City",
      "id": "locationCity",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationCity),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationCity", $$v)
      },
      expression: "editedLocations.locationCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationState",
      "label": "State",
      "id": "locationState",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationState),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationState", $$v)
      },
      expression: "editedLocations.locationState"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationZipcode",
      "label": "Zipcode",
      "id": "locationZipcode",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationZipcode),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationZipcode", $$v)
      },
      expression: "editedLocations.locationZipcode"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text cyan ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteLocation(_vm.location)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-362a5e8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/Edit/EditLocationsDialog.vue
// module id = 669
// module chunks = 1